// extracted by mini-css-extract-plugin
export var readonly = "_gi-1";
export var star = "_gi-0";